module.exports = __webpack_public_path__ + "static/media/Tollinton Market under contruction c. 1863.010742f0.jpg";